<template>
  <div>
    <!-- 按钮区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-button type="primary" @click="openBatchAddDialog">
        批量新增
      </el-button>

      <el-button
        type="primary"
        @click="batchEditPaymentStatus"
        style="margin-left: 20px"
      >
        批量结款
      </el-button>
    </div>

    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-date-picker
        v-model="searchStartDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <span style="margin-left: 20px; margin-right: 20px">~</span>

      <el-date-picker
        v-model="searchStopDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <el-select
        v-model="searchSupplierId"
        filterable
        clearable
        placeholder="供应商筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in supplierList"
          :key="item.objectId"
          :label="item.name"
          :value="item.objectId"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="searchPaymentStatus"
        filterable
        placeholder="结款状态筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in paymentStatusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button type="primary" @click="handleSearch" style="margin-left: 20px">
        筛选
      </el-button>
    </div>

    <!-- 批量新增弹窗 -->
    <el-dialog
      title="批量新增"
      :visible.sync="batchAddDialogVisible"
      width="1350px"
      :close-on-click-modal="false"
    >
      <!-- 动态表单 -->
      <el-form ref="form" :model="batchAddForm">
        <div
          v-for="(item, index) in batchAddForm.parts"
          :key="index"
          class="part-item"
        >
          <el-form-item
            :label="`供应商 ${index + 1}`"
            :prop="`parts.${index}.supplierId`"
          >
            <el-select
              filterable
              v-model="item.supplierId"
              placeholder="选择供应商"
              style="width: 120px"
            >
              <el-option
                v-for="s in supplierList"
                :key="s.objectId"
                :label="s.name"
                :value="s.objectId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期" :prop="`parts.${index}.orderDate`">
            <el-date-picker
              v-model="item.orderDate"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item
            label="订单金额公式"
            :prop="`parts.${index}.orderFormula`"
          >
            <el-input
              v-model="item.orderFormula"
              placeholder="订单金额公式"
              style="width: 250px"
            ></el-input>
          </el-form-item>

          <el-form-item label="订单金额" :prop="`parts.${index}.orderAmount`">
            <el-input
              v-model.number="item.orderAmount"
              placeholder="订单金额"
              @input="
                (val) =>
                  (item.unitPrice = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 100px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="退单金额公式"
            :prop="`parts.${index}.refundFormula`"
          >
            <el-input
              v-model="item.refundFormula"
              placeholder="退单金额公式"
              style="width: 150px"
            ></el-input>
          </el-form-item>

          <el-form-item label="退单金额" :prop="`parts.${index}.refundAmount`">
            <el-input
              v-model.number="item.refundAmount"
              placeholder="退单金额"
              @input="
                (val) =>
                  (item.unitPrice = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 100px"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注" :prop="`parts.${index}.notes`">
            <el-input
              v-model="item.notes"
              placeholder="备注"
              style="width: 150px"
            ></el-input>
          </el-form-item>

          <el-button
            v-if="index > 0"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="removeItem(index)"
          ></el-button>
        </div>
      </el-form>

      <div class="action-bar">
        <el-button @click="addItem" type="primary" icon="el-icon-plus">
          新增条目
        </el-button>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchAddDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="batchAddSubmitForm"
          :loading="batchAddSubmitting"
        >
          提交保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      title="编辑"
      :visible.sync="editDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="100px">
        <el-form-item label="订单金额公式" prop="orderFormula">
          <el-input
            v-model="editForm.orderFormula"
            placeholder="订单金额公式"
          ></el-input>
        </el-form-item>

        <el-form-item label="订单金额" prop="orderAmount">
          <el-input
            v-model.number="editForm.orderAmount"
            placeholder="订单金额"
            @input="
              (val) =>
                (editForm.unitPrice = val
                  .replace(/[^\d.]/g, '')
                  .replace(/\.{2,}/g, '.')
                  .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="退单金额公式" prop="refundFormula">
          <el-input
            v-model="editForm.refundFormula"
            placeholder="退单金额公式"
          ></el-input>
        </el-form-item>

        <el-form-item label="退单金额" prop="refundAmount">
          <el-input
            v-model.number="editForm.refundAmount"
            placeholder="退单金额"
            @input="
              (val) =>
                (editForm.unitPrice = val
                  .replace(/[^\d.]/g, '')
                  .replace(/\.{2,}/g, '.')
                  .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="notes">
          <el-input v-model="editForm.notes" placeholder="备注"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleEditSubmit"
          :loading="editSubmitting"
        >
          保 存
        </el-button>
      </span>
    </el-dialog>

    <!-- 数据统计 -->
    <el-row :gutter="20" class="filter-section" type="flex">
      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="totalOrderAmount"
            title="订单金额"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="totalRefundAmount"
            title="退单金额"
          ></el-statistic>
        </div>
      </el-col>

      <el-col :span="3">
        <div>
          <el-statistic
            group-separator=","
            :precision="2"
            :value="totalAmount"
            title="总金额"
          ></el-statistic>
        </div>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <!-- 复选框列 -->
      <el-table-column
        type="selection"
        width="55"
        :selectable="checkSelectable"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="supplierId"
        label="供货商"
        :formatter="formatSupplierText"
      ></el-table-column>

      <el-table-column
        prop="orderDate"
        label="订单日期"
        width="100"
        :formatter="(row) => $options.filters.formatDate(row.orderDate)"
      ></el-table-column>

      <el-table-column
        prop="orderFormula"
        label="订单金额公式"
        width="300"
      ></el-table-column>

      <el-table-column
        prop="orderAmount"
        label="订单金额"
        width="100"
      ></el-table-column>

      <el-table-column
        prop="refundFormula"
        label="退单金额公式"
        width="200"
      ></el-table-column>

      <el-table-column
        prop="refundAmount"
        label="退单金额"
        width="100"
      ></el-table-column>

      <el-table-column
        prop="totalAmount"
        label="总金额"
        width="100"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="paymentStatus"
        label="结款状态"
        width="100"
        :formatter="formatPaymentStatusText"
      ></el-table-column>

      <el-table-column
        prop="paymentDate"
        label="结款日期"
        width="100"
        :formatter="(row) => $options.filters.formatDate(row.paymentDate)"
      ></el-table-column>

      <el-table-column prop="notes" label="备注" width="200"></el-table-column>

      <el-table-column label="操作" width="200px">
        <template #default="{ row }">
          <el-button
            type="primary"
            size="mini"
            @click="openEditDialog(row)"
            :disabled="!allowPaymentStatusOperate(row)"
          >
            编辑
          </el-button>

          <el-popconfirm
            title="确定已经支付货款了吗？"
            confirm-button-text="确定"
            cancel-button-text="取消"
            :disabled="!allowPaymentStatusOperate(row)"
            @confirm="editPaymentStatus(row)"
          >
            <template #reference>
              <el-button
                type="danger"
                size="mini"
                :disabled="!allowPaymentStatusOperate(row)"
                style="margin-left: 10px"
                >确认结款</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import axios from "axios";

export default {
  filters: {
    formatDate(value) {
      if (!value) return "";
      return value.split("T")[0];
    },
  },
  data() {
    return {
      totalOrderAmount: 0,
      totalRefundAmount: 0,
      totalAmount: 0,
      tableData: [], // 表格数据
      selectedRows: [], // 存储选中行数据

      searchStartDate: Date.now(),
      searchStopDate: Date.now(),
      searchSupplierId: "",
      searchPaymentStatus: 0,

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 总数据量
      loading: false, // 加载状态

      supplierList: [],
      supplierMap: new Map(),

      paymentStatusList: [
        { value: 0, label: "结款状态【全部】" },
        { value: 1, label: "未结款" },
        { value: 2, label: "已结款" },
      ],
      paymentStatusMap: new Map([
        [0, ""],
        [1, "未结款"],
        [2, "已结款"],
      ]),

      batchAddDialogVisible: false,
      batchAddSubmitting: false,
      batchAddForm: {
        parts: [this.emptyItem()],
      },

      editDialogVisible: false,
      editSubmitting: false,
      editForm: {
        objectId: "",
        orderFormula: "",
        orderAmount: 0,
        refundFormula: "",
        refundAmount: 0,
        totalAmount: 0,
        notes: "",
      },
    };
  },

  created() {
    this.fetchData();
    this.fetchSupplierData();
  },

  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true;
        const params = {
          startDate: new Date(this.searchStartDate).toLocaleDateString("en-CA"),
          stopDate: new Date(this.searchStopDate).toLocaleDateString("en-CA"),
          supplierId: this.searchSupplierId,
          PaymentStatus: this.searchPaymentStatus,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };

        const response = await axios.post(
          "/api/SupplierOrder/getOrderInfoList",
          params
        );

        this.totalOrderAmount = response.data.result.totalOrderAmount;
        this.totalRefundAmount = response.data.result.totalRefundAmount;
        this.totalAmount = response.data.result.totalAmount;
        this.tableData = response.data.result.orderDatas;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },

    // 供应商数据加载
    async fetchSupplierData() {
      try {
        const response = await axios.get("/api/Supplier/getAllSupplier");

        this.supplierList = response.data.result;

        this.supplierMap = new Map();
        for (var item of response.data.result) {
          this.supplierMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 格式化供应商字段
    formatSupplierText(row) {
      return this.supplierMap.get(row.supplierId) || "未知供应商";
    },

    // 格式化结款状态字段
    formatPaymentStatusText(row) {
      return this.paymentStatusMap.get(row.paymentStatus) || "未知状态";
    },

    // 切换每页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 打开批量新增弹窗
    openBatchAddDialog() {
      this.batchAddDialogVisible = true;
      this.batchAddForm.parts = [this.emptyItem()];
    },

    // 行数据初始化
    emptyItem() {
      return {
        objectId: "",
        supplierId: "",
        orderDate: Date.now(),
        orderFormula: "",
        orderAmount: 0,
        refundFormula: "",
        refundAmount: 0,
        totalAmount: "",
        paymentStatus: 1,
        notes: "",
      };
    },

    // 插入条目
    addItem() {
      this.batchAddForm.parts.push(this.emptyItem());
    },

    // 移除条目
    removeItem(index) {
      this.batchAddForm.parts.splice(index, 1);
    },

    // 批量新增
    async batchAddSubmitForm() {
      try {
        this.batchAddSubmitting = true;

        var orderList = [];
        for (var order of this.batchAddForm.parts) {
          orderList.push({
            objectId: "",
            supplierId: order.supplierId,
            orderDate: new Date(order.orderDate).toLocaleDateString("en-CA"),
            orderFormula: order.orderFormula,
            orderAmount: order.orderAmount,
            refundFormula: order.refundFormula,
            refundAmount: order.refundAmount,
            totalAmount: 0,
            paymentStatus: 1,
            notes: order.notes
          });
        }

        // 调用批量新增接口
        var response = await axios.post(
          "/api/SupplierOrder/batchInsertSupplierOrder",
          orderList
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("批量新增成功");

          await this.fetchData();

          this.batchAddDialogVisible = false;
        } else {
          this.$message.error(`批量新增失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error(error.response?.data?.message || "提交失败");
      } finally {
        this.batchAddSubmitting = false;
      }
    },

    // 打开编辑弹窗
    openEditDialog(row) {
      this.editForm = {
        objectId: row.objectId,
        orderFormula: row.orderFormula,
        orderAmount: row.orderAmount,
        refundFormula: row.refundFormula,
        refundAmount: row.refundAmount,
        notes: row.notes,
      };
      this.editDialogVisible = true;
    },

    // 提交修改
    async handleEditSubmit() {
      try {
        this.editSubmitting = true;

        // 调用更新接口
        var response = await axios.post(
          "/api/SupplierOrder/editSupplierOrder",
          this.editForm
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();

          this.editDialogVisible = false;
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      } finally {
        this.editSubmitting = false;
      }
    },

    // 是否允许更新结款状态操作
    allowPaymentStatusOperate(row) {
      return row.paymentStatus == 1;
    },

    // 更新结款状态
    async editPaymentStatus(row) {
      try {
        // 调用更新接口
        var response = await axios.post(
          "/api/SupplierOrder/editPaymentStatus",
          [row.objectId]
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      }
    },

    // 选中行变化时触发
    handleSelectionChange(selectedRows) {
      this.selectedRows = [];
      for (var row of selectedRows) {
        this.selectedRows.push(row.objectId);
      }
    },

    // 返回 false 表示禁用选中
    checkSelectable(row, index) {
      return row.paymentStatus == 1 || index == -1;
    },

    // 批量更新结款状态
    async batchEditPaymentStatus() {
      try {
        // 调用更新接口
        var response = await axios.post(
          "/api/SupplierOrder/editPaymentStatus",
          this.selectedRows
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      }
    },
  },
};
</script>

<style scoped>
.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}

.part-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.part-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.action-bar {
  text-align: center;
  margin-top: 20px;
}
</style>
